export default "/coin.f49fec7a-74b929.png";